"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallDesktopMenuContainer = exports.SmallDesktopContainer = exports.SearchContainer = exports.NAVBAR_HEIGHT = exports.MobileMenuContainer = exports.MobileHeaderContainer = exports.MobileContainer = exports.MenuButton = exports.MapControls = exports.Header = exports.GoBackButtonContainer = exports.GoBack = exports.DesktopHeaderContainer = exports.DesktopContainer = exports.Container = exports.BuyCTAWhite = exports.BuyCTA = exports.Button = exports.BottomNavContainer = exports.AircastingLogo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const NAVBAR_HEIGHT = "7.8rem";
exports.NAVBAR_HEIGHT = NAVBAR_HEIGHT;
const Header = styled_components_1.default.header `
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  z-index: 6;
  flex-wrap: wrap;
  position: absolute;

  @media ${media_1.media.desktop} {
    height: ${NAVBAR_HEIGHT};
    position: absolute;
    width: 100%;
    margin: 0 auto;
    top: 0;
    left: 0;
  }
`;
exports.Header = Header;
const MobileContainer = styled_components_1.default.div `
  display: flex;
  padding: 1.5rem 2rem;

  @media ${media_1.media.desktop} {
    display: none;
  }
`;
exports.MobileContainer = MobileContainer;
const DesktopContainer = styled_components_1.default.div `
  display: none;

  @media ${media_1.media.desktop} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 2rem;
    flex-wrap: wrap;
    gap: 1rem;
    flex-direction: flex-reverse;
  }
`;
exports.DesktopContainer = DesktopContainer;
const SearchContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
  border-radius: 10px;
  background-color: ${colors_1.white};
  padding: 1rem 1.5rem;
  gap: 2rem;
`;
exports.SearchContainer = SearchContainer;
const AircastingLogo = styled_components_1.default.img `
  width: ${({ $isSmallScreen }) => ($isSmallScreen ? "3.5rem" : "15rem")};
  height: 4.3rem;
`;
exports.AircastingLogo = AircastingLogo;
const MapControls = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 1.6rem;
  ${(props) => props.$isTimelapseView &&
    `opacity: 0.7;
    pointer-events: none;`}

  @media ${media_1.media.smallDesktop} {
    gap: 1rem;
    padding-left: 0.8rem;
  }

  @media ${media_1.media.desktop} {
    padding-left: 0.8rem;
  }

  @media ${media_1.media.largeDesktop} {
    padding-left: 3.6rem;
  }
`;
exports.MapControls = MapControls;
const Button = styled_components_1.default.button `
  border: none;
  background: none;
`;
exports.Button = Button;
const MenuButton = (0, styled_components_1.default)(Button) `
  background-color: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;

  @media ${media_1.media.mediumDesktop} {
    background-color: ${colors_1.white};
    border-radius: 10px;
    box-shadow: 0px 4px 4px 0px rgba(76, 86, 96, 0.1);
    font-color: ${colors_1.gray400};
    padding: 1.2rem;
    width: 48px;
    height: 42px;
  }
`;
exports.MenuButton = MenuButton;
const BuyCTA = styled_components_1.default.a `
  background-color: ${colors_1.cta};
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.2rem;
  padding: 1.3rem 2rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.14px;
  height: 42px;
  border-radius: 10px;
  gap: 8px;
  text-decoration: none;
  box-shadow: 0px 2px 2px 0px rgba(76, 86, 96, 0.15);

  &:visited,
  &:link,
  &:active {
    color: ${colors_1.gray400};
  }
`;
exports.BuyCTA = BuyCTA;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;
exports.Container = Container;
const BottomNavContainer = (0, styled_components_1.default)(Container) `
  padding-top: 3.2rem;
`;
exports.BottomNavContainer = BottomNavContainer;
const BuyCTAWhite = (0, styled_components_1.default)(BuyCTA) `
  background-color: transparent;
  border: 1px solid ${colors_1.white};
  color: ${colors_1.white};
  border-radius: 0px;
  font-weight: 400;
  padding: 1.8rem 2rem;
  font-size: 1.3rem;

  &:visited,
  &:link,
  &:active {
    color: ${colors_1.white};
  }

  &:hover {
    background-color: ${colors_1.white};
    color: ${colors_1.blue};
  }
`;
exports.BuyCTAWhite = BuyCTAWhite;
const GoBack = styled_components_1.default.a `
  text-decoration: none;
  font-weight: 400;
  font-size: 1.2rem;
  color: ${colors_1.gray400};
  display: flex;
  align-items: center;
  gap: 7px;
  line-height: 22px;
  box-shadow: 0px 2px 2px 0px rgba(76, 86, 96, 0.15);
  background-color: ${colors_1.white};
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;

  @media ${media_1.media.smallDesktop} {
    padding: 1.6rem;
    text-transform: uppercase;
    font-size: 1.4rem;
    height: 4.8rem;
    box-shadow: 0px 4px 4px 0px rgba(76, 86, 96, 0.1);
    justify-content: center;
  }
`;
exports.GoBack = GoBack;
const GoBackButtonContainer = styled_components_1.default.div `
  top: 8rem;
  left: 2rem;
  position: fixed;
`;
exports.GoBackButtonContainer = GoBackButtonContainer;
const DesktopHeaderContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 1.2rem;
`;
exports.DesktopHeaderContainer = DesktopHeaderContainer;
const SmallDesktopContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: min-content;

  @media ${media_1.media.mediumDesktop} {
    display: none;
  }
`;
exports.SmallDesktopContainer = SmallDesktopContainer;
const SmallDesktopMenuContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  height: 32px;
  box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
  background-color: ${colors_1.white};
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  width: min-content;
  border-radius: 10px;

  @media ${media_1.media.mediumDesktop} {
    display: none;
  }
`;
exports.SmallDesktopMenuContainer = SmallDesktopMenuContainer;
const MobileMenuContainer = styled_components_1.default.div `
  width: 61px;
  height: 32px;
  box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
  border-radius: 10px;
  background-color: ${colors_1.white};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
`;
exports.MobileMenuContainer = MobileMenuContainer;
const MobileHeaderContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  flex-wrap: wrap;
  @media ${media_1.media.desktop} {
    display: none;
  }
`;
exports.MobileHeaderContainer = MobileHeaderContainer;
